(() => {
  const norm = (s) => (s || "").toString().trim().toLowerCase();

  /* ======================================================
     ==================== DESKTOP =========================
     ====================================================== */

  const adjustMegaMenuHeight = (root) => {
  if (!root) return;
  root.style.removeProperty('height');
  root.style.removeProperty('min-height');


    void root.offsetHeight;

    requestAnimationFrame(() => {
      const activePanel = root.querySelector('[data-hz-l2-panel].is-active');
      const leftSidebar = root.querySelector('.hz-mega__left');

      if (activePanel && leftSidebar) {
        const panelContentHeight = activePanel.scrollHeight;
        const sidebarHeight = leftSidebar.scrollHeight;
        const finalHeight = Math.max(panelContentHeight, sidebarHeight);

        root.style.minHeight = `${finalHeight}px`;
        root.style.height = `${finalHeight}px`;
      }
    });
  };

  const activate = (root, key) => {
    root.querySelectorAll('[data-hz-l2-link]').forEach(a => a.classList.remove('is-active'));
    root.querySelectorAll('[data-hz-l2-panel]').forEach(p => p.classList.remove('is-active'));

    root.querySelectorAll(`[data-hz-l2-link][data-hz-l2-key="${key}"]`).forEach(a => a.classList.add('is-active'));
    root.querySelectorAll(`[data-hz-l2-panel][data-hz-l2-key="${key}"]`).forEach(p => p.classList.add('is-active'));

    adjustMegaMenuHeight(root);
  };

  const buildL4Map = () => {
    const map = new Map();
    document.querySelectorAll('[data-l4-source][data-l3-key]').forEach(node => {
      const key = norm(node.dataset.l3Key);
      if (!key) return;
      const html = (node.innerHTML || "").trim();
      if (!html) return;
      map.set(key, (map.get(key) || "") + html);
    });
    return map;
  };

  const injectL4IntoRoot = (root, l4Map) => {
    root.querySelectorAll('[data-l4-slot][data-l3-key]').forEach(slot => {
      if (slot.dataset.filled === "1") return;
      const html = l4Map.get(norm(slot.dataset.l3Key));
      if (!html) return;
      slot.innerHTML = html;
      slot.dataset.filled = "1";
    });
  };

  const injectL2RichtextIntoRoot = (root) => {
    root.querySelectorAll('[data-hz-l2-panel]').forEach(panel => {
      if (panel.dataset.l2RichtextInjected === "1") return;
      const key = norm(panel.dataset.hzL2Key);
      const source = document.querySelector(`[data-l2-richtext][data-l2-key="${key}"]`);
      if (!source) return;

      const grid = panel.querySelector('.hz-mega__grid');
      if (!grid) return;

      const banner = document.createElement('div');
      banner.className = 'hz-mega__l2-richtext';
      banner.innerHTML = `
        <div class="hz-mega__l2-richtext-arrow" data-dir="left">‹</div>
        <div class="hz-mega__l2-richtext-track">${source.innerHTML}</div>
        <div class="hz-mega__l2-richtext-arrow" data-dir="right">›</div>
      `;
      grid.parentNode.insertBefore(banner, grid);
      panel.dataset.l2RichtextInjected = "1";
    });
  };

  const injectL2PromoIntoRoot = (root) => {
    root.querySelectorAll('[data-hz-l2-panel]').forEach(panel => {
      if (panel.dataset.l2PromoInjected === "1") return;
      const key = norm(panel.dataset.hzL2Key);
      const sources = document.querySelectorAll(`[data-l2-promo][data-l2-key="${key}"]`);
      if (!sources.length) return;

      const grid = panel.querySelector('.hz-mega__grid');
      if (!grid) return;

      panel.classList.add('has-l2-promo');

      sources.forEach(src => {
        if (!src.dataset.image) return;
        const col = document.createElement('div');
        col.className = 'hz-mega__col hz-mega__col--promo';
        col.innerHTML = `
          <div class="mega-menu-second-level-promo">
            <a href="${src.dataset.link || '#'}" class="mega-menu-second-level-promo__wrapper">
              <img src="${src.dataset.image}" class="mega-menu-second-level-promo__image">
              ${src.dataset.label ? `<span class="mega-menu-second-level-promo__label" style="color:${src.dataset.labelColor}">${src.dataset.label}</span>` : ''}
            </a>
          </div>`;
        grid.appendChild(col);

        const img = col.querySelector('img');
        if (img && !img.complete) {
          img.onload = () => adjustMegaMenuHeight(grid.closest('[data-hz-mega]'));
        }
      });

      panel.dataset.l2PromoInjected = "1";
    });
  };

  const initDesktop = () => {
    const l4Map = buildL4Map();
    document.querySelectorAll('[data-hz-mega]').forEach(root => {
      if (root.dataset.hzInit === "1") return;
      root.dataset.hzInit = "1";

      const first = root.querySelector('[data-hz-l2-link]');
      if (first) activate(root, first.dataset.hzL2Key);

      root.addEventListener('mouseover', e => {
        const link = e.target.closest('[data-hz-l2-link]');
        if (link) activate(root, link.dataset.hzL2Key);
      }, true);

      injectL4IntoRoot(root, l4Map);
      injectL2RichtextIntoRoot(root);
      injectL2PromoIntoRoot(root);
    });
  };

  /* ======================================================
     =============== INIT + OBSERVER SICURO ================
     ======================================================

     FIX: il precedente MutationObserver osservava TUTTO il
     document.documentElement con subtree:true e richiamava
     initDesktop() ad ogni mutazione. Visto che initDesktop
     modifica a sua volta il DOM (insertBefore, appendChild,
     innerHTML), l'observer si auto-triggerava creando un
     loop che freezzava il thread JS appena il dialog di
     ricerca (o qualsiasi altra modifica pesante al DOM)
     si apriva, bloccando l'intera pagina.

     Soluzione:
     1) Ambito di osservazione limitato al nodo che contiene
        effettivamente i mega-menu (header), non a tutto
        il documento.
     2) Debounce + controllo "già inizializzato" per evitare
        esecuzioni a raffica.
     3) Observer temporaneamente disconnesso mentre
        initDesktop modifica il DOM, così non si auto-triggera.
  */

  let scheduled = false;
  let observer = null;

  const safeInit = () => {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;

      // Se non ci sono mega-menu non inizializzati, non fare nulla
      const pending = document.querySelector('[data-hz-mega]:not([data-hz-init="1"])');
      const pendingSlot = document.querySelector('[data-l4-slot]:not([data-filled="1"])');
      if (!pending && !pendingSlot) return;

      // Disconnetti l'observer mentre modifichiamo il DOM, poi riconnetti
      if (observer) observer.disconnect();
      try {
        initDesktop();
      } catch (err) {
        console.error('[hz-mega-vertical] init error:', err);
      }
      if (observer) attachObserver();
    });
  };

  const attachObserver = () => {
    // Osserva solo l'header (dove vivono i mega-menu), NON l'intero document
    const target = document.querySelector('header') || document.querySelector('#header-component') || document.body;
    if (!target) return;
    observer = new MutationObserver(safeInit);
    observer.observe(target, { childList: true, subtree: true });
  };

  // Run iniziale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initDesktop();
      attachObserver();
    });
  } else {
    initDesktop();
    attachObserver();
  }

  document.addEventListener('click', e => {
    const arrow = e.target.closest('.hz-mega__l2-richtext-arrow');
    if (!arrow) return;
    const track = arrow.parentElement.querySelector('.hz-mega__l2-richtext-track');
    if (track) track.scrollBy({ left: arrow.dataset.dir === 'right' ? 200 : -200, behavior: 'smooth' });
  });

})();